import React from 'react';
import PropTypes from 'prop-types';
import PieChart from 'Common/components/PieChart';
import colors from 'Common/constants/colors';

const OverallProgress = ({ stats }) => {
    const percentage =
        stats.all > 0 ? Math.floor((stats.completed / stats.all) * 100) : 0;

    return (
        <PieChart
            data={[
                {
                    id: 'completed',
                    label: 'Abgeschlossen',
                    value: stats.completed,
                    backgroundColor: colors.PRIMARY,
                },
                {
                    id: 'pending',
                    label: 'Ausstehend',
                    value: stats.pending,
                    backgroundColor: colors.SEARCH_FIELD_BORDER,
                },
                {
                    id: 'others',
                    label: 'Andere',
                    value: stats.all - stats.completed - stats.pending,
                    backgroundColor: colors.SEARCH_FIELD_BORDER,
                },
            ]}
            percentage={percentage}
            text="Aller Aufgaben"
            size={120}
        />
    );
};

OverallProgress.propTypes = {
    stats: PropTypes.object.isRequired,
};

export default OverallProgress;
